<template>
    <v-container class="pa-0 pb-12">
		<v-row class="px-3 fill-height"><v-col>
				<v-alert type="success">
			{{message}}
				</v-alert>
		</v-col></v-row>
	</v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import namespace from '../store/namespace';
import eventRegistrationActions from '../store/actions/eventRegistration';

export default {
	name: 'RegistrationFinished',
	async mounted() {
		if (this.Links.length === 0) await this.GET_EVENT_REG_LINKS();
		if (this.cGuid) {
			const link = this.Links.find(x => x.rel === 'confirm_mail');
			if (link) {
				const href = link.href
					.replace('{attendanceId}', this.cGuid);
				this.message = await this.CONFIRM_MAIL(href);
			}
		} else if (this.rGuid) {
			const link = this.Links.find(x => x.rel === 'remove_att');
			if (link) {
				const href = link.href
					.replace('{attendanceId}', this.rGuid);
				this.message = await this.REMOVE_ATTENDENCE(href);
			}
		} else {
			this.message = this.$t('text.noDataText');
		}
	},
	data() {
		return {
			message: '',
		};
	},
	methods: {
		...mapActions(namespace.EVENTREGISTRATION, [
			eventRegistrationActions.GET_EVENT_REG_LINKS,
			eventRegistrationActions.REMOVE_ATTENDENCE,
			eventRegistrationActions.CONFIRM_MAIL]),
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.EVENTREGISTRATION, ['Links']),
		cGuid() {
			if (this.$route.params.cGuid) return this.$route.params.cGuid;
			return null;
		},
		rGuid() {
			if (this.$route.params.rGuid) return this.$route.params.rGuid;
			return null;
		},
	},
};
</script>

<style lang="scss" scoped>
	@import "../globalComponents/style/_globals";

	.fill-height {
		color: $font-light-color;
	}
</style>
